// Basic configuration for the application
export const API_BASE_URL = "https://screening.fanisko.com";
// export const API_BASE_URL = "http://127.0.0.1:8000";


// Default configuration for the Calendar application
export const DEFAULT_CONFIG = {
    EMAIL_ID: 'balaji@fanisko.com',
    FETCH_DAYS: 2,
    SLOT_DURATION: 30, // in minutes
    SLOT_INCREMENT: 30, // in minutes (granularity of slot start times)
    WORKING_HOURS: {
        start: 9,
        end: 18
    },
    // Absolute URLs using API_BASE_URL to ensure they work from any page
    API_URL: `${API_BASE_URL}/api/list-events`,
    SEND_EMAIL_URL: `${API_BASE_URL}/api/send_email`,
    BOOKING_DEFAULT: {
        Company: "Fanisko",
        candidate_name: "G Agent Tester",
        candidate_email: "gagenttester@gmail.com",
        position: "Software Engineer",
        interview_level: "Technical L3",
        timezone: "Asia/Kolkata",
        interviewers: [
            { name: "balaji", email: "balaji@fanisko.com" },
            { name: "ZealBala", email: "zealbalaji@gmail.com" }
        ],
        candidate_id: "", // To be filled from URL
        job_id: ""        // To be filled from URL
    }
};

/**
 * Helper to get config from URL parameters or defaults.
 * This allows the calendar page to be dynamic based on the URL.
 * Example: ?email=recruiter@example.com&days=5&candidate_id=123&job_id=456
 */
export const getConfig = () => {
    const queryParams = new URLSearchParams(window.location.search);

    const duration = parseInt(queryParams.get('duration')) || DEFAULT_CONFIG.SLOT_DURATION;
    const increment = parseInt(queryParams.get('increment')) || duration || DEFAULT_CONFIG.SLOT_INCREMENT;

    // Merge defaults with URL parameters
    const config = {
        EMAIL_ID: queryParams.get('email') || DEFAULT_CONFIG.EMAIL_ID,
        FETCH_DAYS: parseInt(queryParams.get('days')) || DEFAULT_CONFIG.FETCH_DAYS,
        SLOT_DURATION: duration,
        SLOT_INCREMENT: increment,
        WORKING_HOURS: {
            start: parseInt(queryParams.get('start_hour')) || DEFAULT_CONFIG.WORKING_HOURS.start,
            end: parseInt(queryParams.get('end_hour')) || DEFAULT_CONFIG.WORKING_HOURS.end,
        },
        API_URL: DEFAULT_CONFIG.API_URL,
        SEND_EMAIL_URL: DEFAULT_CONFIG.SEND_EMAIL_URL,
        // Update booking defaults with specific candidate/job info from URL if present
        BOOKING_DEFAULT: {
            ...DEFAULT_CONFIG.BOOKING_DEFAULT,
            candidate_id: queryParams.get('candidate_id') || DEFAULT_CONFIG.BOOKING_DEFAULT.candidate_id,
            job_id: queryParams.get('job_id') || DEFAULT_CONFIG.BOOKING_DEFAULT.job_id,
            candidate_name: queryParams.get('name') || DEFAULT_CONFIG.BOOKING_DEFAULT.candidate_name,
            candidate_email: queryParams.get('candidate_email') || DEFAULT_CONFIG.BOOKING_DEFAULT.candidate_email
        }
    };

    return config;
};


